import { render, staticRenderFns } from "./MetricsInstitution.vue?vue&type=template&id=6a616cca&scoped=true"
import script from "./MetricsInstitution.vue?vue&type=script&lang=js"
export * from "./MetricsInstitution.vue?vue&type=script&lang=js"
import style0 from "./MetricsInstitution.vue?vue&type=style&index=0&id=6a616cca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a616cca",
  null
  
)

export default component.exports